import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { CenteredContent } from '#/components/CenteredContent/CenteredContent';
import { ErrorSection } from '#/components/ErrorSection/ErrorSection';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { Layout } from '#/layouts/Layout/Layout';
import { log } from '#/utils/logging';
import { trackError } from '#/utils/trackError';

// Note: this route will cease to exist after we're fully migrated to horizon
export function RouteErrorBoundary() {
  const { i18n } = useI18n();

  const error = useRouteError();

  useEffect(() => {
    log.error(`stacktrace:\n${(error as Error).stack}`);
    trackError(error as Error);
  }, [error]);

  return (
    <RouteModule title={i18n('Something Went Wrong')}>
      <Layout>
        <CenteredContent>
          <ErrorSection error={error as Error} />
        </CenteredContent>
      </Layout>
    </RouteModule>
  );
}
